import { render, staticRenderFns } from "./tuceList.vue?vue&type=template&id=5e5e7585&scoped=true&"
import script from "./tuceList.vue?vue&type=script&lang=js&"
export * from "./tuceList.vue?vue&type=script&lang=js&"
import style0 from "./tuceList.vue?vue&type=style&index=0&id=5e5e7585&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5e7585",
  null
  
)

export default component.exports